import styled from 'styled-components';
import { FiCheckCircle } from 'react-icons/fi';

export const RulesContainer = styled.div`
  line-height: 0;
  display: flex;
  flex-flow: row wrap;
  align-content: space-between;
  justify-content: space-between;
  margin: 8px 0 25px;

  @media (max-width: 380px) {
    flex-flow: column;
  }
`;

interface RuleItemProps {
  success?: boolean;
}

export const RuleItem = styled.span<RuleItemProps>`
  display: flex;
  font-size: 0.8rem;
  margin: 4px 0px;
  align-items: center;
  color: ${({ success }) => (success ? 'green' : 'gray')};
`;

export const Icon = styled(FiCheckCircle).attrs(() => ({ size: 14 }))`
  margin-right: 5px;
`;
